/**
 * Class PassiveRequest
 * @param $gameID {Stirng}
 * @returns {Object} API
 *
 * This class executes the loads from the datasources requested by the initial config
 * It attempts to use a tiered, dependency-driven chain of loading so as to not
 */
define('GameDayCore/GDModel/load/manager/PassiveRequest',['require','exports','module','../../../GDControl/GameModelLocator/GameModelLocator','../../../GDControl/SubscriptionManager/SubscriptionManager','message-service/message-service','data-fetcher/data-fetcher','../execute/FileRequestItem','../../storage/ModelCache','extant/extant','../../../GDUtil/window/Logg','../../enums/datasources/Datasources','../../enums/datasources/DatasourceToEventMap','../../enums/events/EventTypes'],function(require,exports,module) {
    var GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        SubsManager = require("../../../GDControl/SubscriptionManager/SubscriptionManager"),
        MessageService = require("message-service/message-service"),
        dataFetcher = require("data-fetcher/data-fetcher"),
        FileRequestItem = require("../execute/FileRequestItem"),
        ModelCache = require("../../storage/ModelCache"),
        exists = require("extant/extant"),
        logg = require("../../../GDUtil/window/Logg"),
        Datasources = require("../../enums/datasources/Datasources"),
        DatasourceToEventMap = require("../../enums/datasources/DatasourceToEventMap"),
        EventTypes = require("../../enums/events/EventTypes");

    function PassiveRequest($gameId,$gameItem) {
        var gameID = $gameID,
            gameItem = $gameItem,
            loadCnt = 0,
            partialLoadCnt = 0,
            gameParams,
            firstLoad = true;

        this.loadGameData = function() {
            executeInitialLoad(gameItem.addGameParams());
        };

        /**
         * Function executeInitialLoad
         * @param params {Object} the Load params object for the datasource Manager
         *
         * If the plays file is in the requests, it loads it,
         */
        function executeInitialLoad(params) {
            this.active = true;
            loadCnt = SubsManager.getSubscriptions().length;

            gameParams = params || gameItem.addGameParams();

            // check if they want the primary file...
            if (SubsManager.checkSubscription(Datasources.PLAYS)) {
                dataFetcher.get(new FileRequestItem(Datasources.PLAYS, true, gameParams, handleInitialLoad));
            } else { // proceed to the secondary
                executeSecondaryLoads()
            }
        }

        /**
         * Function handleInitialLoad
         * @param result {Object} data payload from Load request
         *
         * processes the the plays file Load and initiate the next set of loads
         */
        function handleInitialLoad(result) {
            if (!exists(result.data)) {
                executeSecondaryLoads();
                logg.log("plays file failed to Load, sorry.");

                return;
            }

            var plays = result.data;
            loadCnt--;

            storeLoaded(result);
            $.extend(gameParams, { inning: plays.inning });

            executeSecondaryLoads(plays.inning);
        }

        /**
         * function executeSecondaryLoads
         * @param $inning {String} value (or not) from the plays file
         *
         * Load the boxscore and inning if requested
         */
        function executeSecondaryLoads($inning) {
            if (!this.active) {
                return;
            }

            var loadBox = SubsManager.checkSubscription(Datasources.BOXSCORE),
                loadInnings = (SubsManager.checkSubscription(Datasources.inning) && exists($inning));

            if (SubsManager.checkSubscription(Datasources.inning) && !exists($inning)) {
                logg.log("could not Load requested inning file due to no inning number available from plays.");
                loadCnt--;
            }

            partialLoadCnt = 0;

            if (loadBox) {
                partialLoadCnt++;
                dataFetcher.get(new FileRequestItem(Datasources.BOXSCORE, true, gameParams, handleSecondaryLoads));
            }

            if (loadInnings) {
                partialLoadCnt++;
                dataFetcher.get(new FileRequestItem(Datasources.INNING, true, gameParams, handleSecondaryLoads));
            }

            if (!loadBox && !loadInnings) {
                executeTertiaryLoads();
            }
        }

        /**
         * Function handleSecondaryLoads
         * @param result {Object} the file Load results: value obj + Load info
         */
        function handleSecondaryLoads(result) {
            partialLoadCnt--;
            loadCnt--;

            if (exists(result.data)) {
                storeLoaded(result);
            }

            if (partialLoadCnt === 0) {
                executeTertiaryLoads();
            }
        }

        /**
         * Function executeTertiaryLoads
         *
         * Load the bench file and the scoring plays if asked for...
         * if not move on to everything else
         */
        function executeTertiaryLoads() {
            if (!this.active) {
                return;
            }

            var loadBench = SubsManager.checkSubscription(Datasources.BENCH),
                loadScoring = SubsManager.checkSubscription(Datasources.SCORING_PLAYS);

            partialLoadCnt = 0;

            if (loadBench) {
                partialLoadCnt++;
                dataFetcher.get(new FileRequestItem(Datasources.BENCH, true, gameParams, handleTertiaryLoads));
            }

            if (loadScoring) {
                partialLoadCnt++;
                dataFetcher.get(new FileRequestItem(Datasources.SCORING_PLAYS, true, gameParams, handleTertiaryLoads));
            }

            if (!loadBench && !loadScoring) {
                executeFinalLoads();
            }
        }

        /**
         * Function handleTertiaryLoads
         * @param result {Object} the file Load results: value obj + Load info
         */
        function handleTertiaryLoads(result) {
            partialLoadCnt--;
            loadCnt--;

            if (exists(result.data)) {
                storeLoaded(result);
            }

            if (partialLoadCnt === 0) {
                executeFinalLoads();
            }
        }

        /**
         * Function executeFinalLoads
         *
         * Load any remainder files in the subscriptions list
         */
        function executeFinalLoads() {
            if (!this.active) {
                return;
            }

            var subs = trimSubs(SubsManager.getSubscriptions());

            for (var i = 0, l = subs.length; i < l; i++) {
                dataFetcher.get(new FileRequestItem(subs[i], true, gameParams, handleFinalLoads));
            }
        }

        /**
         * Function handleFinalLoads
         * @param result {Object} the file Load results: value obj + Load info
         */
        function handleFinalLoads(result) {
            loadCnt--;

            if (exists(result.data)) {
                storeLoaded(result);
            }

            if (loadCnt === 0) {
                if (firstLoad) {
                    firstLoad = false;
                    dispatchUpdates(EventTypes.INIT_DATA_LOADED);
                }
                dispatchUpdates(EventTypes.UPDATE);
            }
        }

        /**
         * Function trimSubs
         * @param arr {Array} the total list of subscribed items
         * @returns {Array} the same array, minus all the files that might have been loaded previously in this process
         */
        function trimSubs(arr) {
            var subs = [].concat(arr);

            for (var i = 0, l = subs.length; i < l; i++) {
                switch (subs[i]) {
                    case Datasources.PLAYS:
                    case Datasources.BOXSCORE:
                    case Datasources.INNING:
                    case Datasources.BENCH:
                    case Datasources.SCORING_PLAYS:
                        subs.splice(i, 1);
                        i--;
                        break;
                }
            }

            return subs;
        }

        /**
         * Function storeLoaded
         * @param data {Object} the value object from the Load
         * @param src {String} which datasource the VO is associated with
         *
         * Stores the any given data source in the ModelCache by game id, datasource and time
         */
        function storeLoaded(result) {
            ModelCache.storeGameData(gameID, result, (new Date()).getTime());
            dispatchUpdates(DatasourceToEventMap[result.dataSourceName]);
        }

        /**
         * Function dispatcUpdates
         * @param evt {String} the event to dispatch
         */
        function dispatchUpdates(evt) {
            MessageService.publish(EventTypes[evt]);
        }
    }

    /**
     * API
     */
    PassiveRequest.prototype = {
        active: false,
        loadGameData: function() { },
        stop: function () {
            this.active = false;
        },
        init : function(){
            this.start();
        },
        start: function(){
            this.active=true;
            this.loadGameData()
        },
        pause: function () {
            this.active = true;
        },
        isActive: function () {
            return this.active;
        }
    };

    return PassiveRequest;
});
